import { c as _c } from "react/compiler-runtime";
import CourseItem from '@classify/react-product-components/CourseItem';
import { parse as parseDuration } from '@openclassrooms/date-time/duration';
import { getLearningContentWording } from '@openclassrooms/common-app/learningContent';
export interface CourseLinkCardTranslations {
  levelAriaLabel?: string;
}
export interface CourseLinkCardData {
  title: string;
  illustration: string;
  category?: string;
  categoryColor?: string;
  description?: string;
  shortDescription?: string;
  displayDifficulty?: string;
  OpenClassroomsUrl?: string;
  duration?: string;
}
interface Props {
  course: CourseLinkCardData;
  href: string;
  translations?: CourseLinkCardTranslations;
}
const CourseLinkCard = t0 => {
  const $ = _c(19);
  const {
    course,
    href,
    translations: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const translations = t2;
  const description = course.description || course.shortDescription;
  let t3;
  if ($[2] !== course.duration) {
    const parsedDuration = parseDuration(course.duration).hours;
    t3 = getLearningContentWording().durationHours(parsedDuration);
    $[2] = course.duration;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const formattedDuration = t3;
  const t4 = course.OpenClassroomsUrl || href;
  const t5 = course.category || "";
  const t6 = course.categoryColor || "";
  let t7;
  if ($[4] !== t5 || $[5] !== t6) {
    t7 = {
      name: t5,
      color: t6
    };
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== translations.levelAriaLabel) {
    t8 = {
      levelAriaLabel: translations.levelAriaLabel
    };
    $[7] = translations.levelAriaLabel;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      color: "initial !important",
      "&:visited": {
        color: "initial !important"
      }
    };
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== course.displayDifficulty || $[11] !== course.illustration || $[12] !== course.title || $[13] !== description || $[14] !== formattedDuration || $[15] !== t4 || $[16] !== t7 || $[17] !== t8) {
    t10 = <CourseItem data-testid="course-link-card" component="a" href={t4} target="_blank" rel="noopener noreferrer" level={course.displayDifficulty} duration={formattedDuration} description={description} illustration={course.illustration} title={course.title} category={t7} translations={t8} sx={t9} />;
    $[10] = course.displayDifficulty;
    $[11] = course.illustration;
    $[12] = course.title;
    $[13] = description;
    $[14] = formattedDuration;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};
export default CourseLinkCard;